import React from 'react';
import { createRoot } from 'react-dom/client';
import { CookiesProvider } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

const container = document.getElementById('root');

const root = createRoot(container);
root.render(
  <HelmetProvider>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </HelmetProvider>,
);
